<span class="fcp-link-content"><ng-content></ng-content></span>
